import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import Upakram from "../../components/public/upakram";
import Footer from "../../components/public/footer";

export default () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"उपक्रम"} content={<Upakram />} />
      <Footer />
    </>
  );
};
